module.exports = __webpack_public_path__ + "static/media/Ubicacion.57d4f536.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Ubicacion.svg
// module id = 2067
// module chunks = 0